// Titel der Seite im Browser-Tab: „Bestand · Merxo“. Die Hülle setzt ihn aus dem Manifest der Route
// (setRouteTitle); eine Seite kann ihn genauer machen: usePageTitle('Artikel 10234').
import { useEffect } from 'react'
import { pageTitle } from '@shared/brand'

let routeTitle: string | null = null
const overrides: { title: string }[] = []

function apply(): void {
  if (typeof document === 'undefined') return
  document.title = pageTitle(overrides.at(-1)?.title ?? routeTitle ?? undefined)
}

/** Titel der Route (aus dem Manifest). Nur die Hülle ruft das auf. */
export function setRouteTitle(title: string | null): void {
  routeTitle = title
  apply()
}

/** Genauerer Titel, solange die Komponente steht; danach gilt wieder der Titel der Route. */
export function usePageTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) return
    const entry = { title }
    overrides.push(entry)
    apply()
    return () => {
      const index = overrides.indexOf(entry)
      if (index >= 0) overrides.splice(index, 1)
      apply()
    }
  }, [title])
}
